import React from 'react';
import axios from 'axios';
import {Row, Col, Form, Button, Layout, message, Modal, Icon} from 'antd';
import moment from 'moment';
import 'moment/locale/es';
import * as etiquetas from '../../ApplicationResources';
import Template from '../interfaz/Template';
import DatosCredencial from './DatosCredencial';
import DatosPersonales from './DatosPersonales';
import DatosDireccion from './DatosDireccion';
import DatosEscolaridad from './DatosEscolaridad';
import MedioConvocatoria from './MedioConvocatoria';
import ExperienciaLaboral from './ExperienciaLaboral';
import DatosOtros1 from './DatosOtros1';
import DatosOtros2 from './DatosOtros2';
import DatosOtros3 from './DatosOtros3';
import DatosOtros4 from './DatosOtros4';
import DatosOtros5 from './DatosOtros5';
import Wizard from '../interfaz/Wizard.js';
import ProgresoRegistro from '../interfaz/ProgesoRegistro';
import {registrarTerminado, cambiarEstatus} from '../../redux/user/user-actions';
import {emitirOperacion} from '../../redux/actions/accionesOperacion'
import AuthenticatedComponent from '../../componentes/AuthenticatedComponent';
import {connect} from 'react-redux';
import siderRegistro from '../../img/sider_registro.png';
import {withRouter} from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import '../../css/registroAspi.css';
import errorImgModal from '../../img/error_icon.svg';
import { selectAspirante,selectCurrentUser } from '../../redux/user/user-selectors';
import { selectDistrito, selectEstado, selectProceso } from '../../redux/menu/menu-selectors';
import Menu from '../interfaz/Elements/Menu';
import HeaderModule from '../interfaz/Elements/HeaderModule';


moment.locale('es');

const { Item } =Form;
const {Sider, Content} = Layout;
let msjError = "";

class Aspirante extends React.Component {
    constructor(props) {
        // Calling the constructor of
        // Parent Class React.Component
        super(props);
        // Setting the initial state
        this.stateModifica = {
            folio: null,
            claveElector: null,
            motivoParticipar: this.props.motivoParticipar,
            datosUsuario: this.props.datosUsuario,
            soloFUAR: this.props.fuar
        };
        this.wizard = {};

    }

    state = {
        disableAceptar: true,
        porcentaje: 0,
        cargado: true,
        statusVisible: true, /* bandera de visibilidad de guia*/
        modifica: false,    /* bandera que dice se esta accediendo desde el modifica*/
        cargando: false,
        guia: true,
        rolConsulta: false,
        msjError : "",
        abrirModalError : false,
        mjs: "",
        modalAbrir: false,
        tituloHeaderModule : etiquetas.datos_nombre_modulo_registro
    }


    objetos = [];
    componentDidMount() {
        if(this.props.modifica === true){  // si es modifica entonces desaparece el  guia de estatus
            this.setState({statusVisible:false, modifica : true});
        }
    }



    formularioCorrecto = (valido, _valores, callbackResponse) => {
        if (this.state.disableAceptar !== !valido)
            this.setState({disableAceptar: !valido});

        this.callbackResponse = callbackResponse;
    }

    cerrarErrorModal(){
      this.setState({abrirModalError:false});
    }

    enviarServidor = () => {
        let participacionDef = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion;
        let aspirante = {};
        let idCorte = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idCorte.value;

        // Solo en registro se setea la participación como distrito
        if(this.state.modifica ===  false)
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito;

        this.props.objetos.forEach(function (objeto, index) {

            const keys = Object.keys(objeto);
            for (const key of keys) {
                const obj = objeto[key];
                if(obj instanceof Object) {
                    if('value' in obj){
                        if(obj.value instanceof moment){
                            if(key === 'tiempoTraslado'){
                                aspirante[key] = moment(obj.value).
                                                                format('HH:mm');
                            }else{
                                aspirante[key] = obj.value.format('YYYY-MM-DD');
                            }
                        } else {
                            aspirante[key] = obj.value !== undefined &&
                                                obj.value !== ""?obj.value:null;
                        }
                    }
                } else {
                    aspirante[key] = obj;
                }
            }
        });

        aspirante.idCorte = idCorte;
        
        const jwt = localStorage.getItem("jwt-token");
        const headers = {
            'Accept': 'application/json'
            ,'Content-Type': 'application/json'
        };

        if(jwt){
            headers['Authorization'] = jwt;
        }

        if(this.state.modifica ===  false){
            this.setState({cargando: true});
            axios.post(process.env.REACT_APP_API_URL +
                                   '/centralReclutaSEyCAE/ws/registra_aspirante'
            , aspirante
            , {
                headers
            }
        ).then(_response => {
            this.wizard.current.form.resetFields();
            this.props.registrarTerminado(true);
            this.props.cambiarEstatus(1);
            this.props.emitirOperacion({
                folioAcceso: _response.data
                , idProcesoElectoral: aspirante.idProcesoElectoral
                , idDetalleProceso: aspirante.idDetalleProceso
                , idParticipacion: participacionDef
                , idConvocatoria: aspirante.idConvocatoria
                , claveElectorFuar: aspirante.claveElectorFuar
                , correoElectronico: aspirante.correoElectronico
            });
            this.props.history.push('/exito_registro');
        }).catch(error => {
            this.setState({cargando: false});
            console.error("Error al guardar el aspirante "+
                "enviarServidor()",error);
            if (error.response){
                if (error.response.status === 409){
                    msjError = error.response.data.message;
                } else if (error.response.data && error.response.data.causa
                    && error.response.data.causa.includes("Error de validación")){
                    msjError = error.response.data.message;
                } else {
                    msjError = etiquetas.gral_error_cau;
                }
            } else {
                msjError = etiquetas.gral_error_cau;
            }
            this.setState({
              msjError : msjError,
              abrirModalError : true
            });
        });
        }
        if(this.state.modifica ===  true){
            const jwt = localStorage.getItem("jwt-token");
            this.setState({cargando: true});
            axios.post(process.env.REACT_APP_API_URL +
                                   '/centralReclutaSEyCAE/ws/modifica_aspirante'
            , aspirante
            , {
                headers: {
                    'Accept': 'application/json'
                    ,'Content-Type': 'application/json'
                    , Authorization: jwt
                }
            }
        ).then(_response => {
            if(_response.data.code !== 201){
                if(this.props.datosAspirante) {
                    // Solo aplica para usuarios externos (usuario aspirante)
                    this.props.datosAspirante.estatusRegistro = _response.data.data.estatusRegistro;
                    this.props.datosAspirante.bPlatica = _response.data.data.fechaCapsula !== null ? 0 : null;
                    this.props.datosAspirante.bObservacion = _response.data.data.bObservaciones;
                }

                this.props.history.push('/exito_modifica');
            }else{
                msjError = _response.data.data
                this.setState({cargando: false});
                this.setState({
                    msjError : msjError,
                    abrirModalError : true
                  });
            }
        }).catch(error => {
            this.setState({cargando: false});
            console.error("Error al actualizar el aspirante "+
                "enviarServidor()",error);
            if (error.response){
                if (error.response.status === 409){
                    msjError = error.response.data.message;
                } else if (error.response.data && error.response.data.causa
                    && error.response.data.causa.includes("Error de validación")){
                    msjError = error.response.data.message;
                } else {
                    msjError = etiquetas.gral_error_cau;
                }
            } else {
                msjError = etiquetas.gral_error_cau;
            }
            this.setState({
              msjError : msjError,
              abrirModalError : true
            });
        });
        }
    }

    callbackPaso = (indice, total) => {
        this.setState({porcentaje: (indice + 1) * (100 / total)});
    }

    /**
     * Función que valida si el aspirante se encuentra registrado en la convocatoria especificada o en una previa
     */
    getValidaConvocatoria = (idConvocatoria) => {
        const { proceso } = this.props;
        const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
        const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

        var postData = {
            "idProcesoElectoral" : idProcesoElectoral,
            "idDetalleProceso" : idDetalleProceso,
            "idEstado" : this.props.objetos
                      [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value,
            "seccion" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? 
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value : this.props.objetos
                        [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value,
            "claveElectorFuar" : this.props.objetos
                        [etiquetas.WIZARD_DATOS_CREDENCIAL]['claveElectorFuar'].value,
            "idConvocatoria" : idConvocatoria
          }
  
          // Obtenido los datos del servidor
          axios.post(process.env.REACT_APP_API_URL +
            '/centralReclutaSEyCAE/ws/convocatoriaJD', postData,
            {
                  headers: {
                      'Accept': 'application/json'
                      ,'Content-Type': 'application/json'
                  }
              }
          ).then(response => {
              if(response.data !== ""){ 
                let idDistritoAntes = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito;
                let idParticipacionAntes = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion;
                Object.assign(this.props.objetos
                    [etiquetas.WIZARD_DATOS_CREDENCIAL], response.data);

                    this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = idDistritoAntes;
                    this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion = idParticipacionAntes;
                  // Verificamos si el aspirante se encuentra registrado en la convocatoria vigente
                  if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].registradoConvocatoriaVigente == true){
                      this.setState({
                      msjError : etiquetas.gral_clave_en_convocatoria_seleccionada,
                      abrirModalError : true
                      });
  
                      Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], { 
                      'claveElectorFuar': {'value': undefined}});

                      Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], { 
                        'claveElectorFuarRepetir': {'value': undefined}});
                        Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], { 
                            'fechaSolicitud': {'value': undefined}});
  
                      this.callbackResponse({0: {claveElectorFuar: {
                          error: etiquetas.gral_clave_en_convocatoria_seleccionada
                        }}});
                  }
                  /* Verificamos si el aspirante se encuentra registrado en una convocatoria previa
                  else if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].registradoConvocatoriaPrevia == true) {
                      this.setState({mjs: 'La clave de elector ingresada se encuentra registrada en la convocatoria número ' + this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].numeroConvocatoriaPrevia + ", periodo de registro: " + this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].fechaRegistroInicioPrevia + " al " + this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].fechaRegistroFinPrevia});
                      this.setState({modalAbrir:true});
                  }*/
  
                  if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].registradoConvocatoriaVigente == false)
                      this.wizard.current.cambiaNegocio('id_convocatoria', true);
              } else {
                  this.callbackResponse({0: {id_convocatoria: {
                    error: etiquetas.gral_no_convo_activa_seccion
                  }}});
              }
          }).catch(error => {
            console.error("Error al obtener la convocatoria "+
                "getConvocatoria()",error);
            if (error.response){
                if (error.response.status === 409){
                    msjError = error.response.data.message;
                } else if (error.response.data && error.response.data.causa
                    && error.response.data.causa.includes("Error de validación")){
                    msjError = error.response.data.message;
                } else {
                    msjError = etiquetas.gral_error_cau;
                }
            } else {
                msjError = etiquetas.gral_error_cau;
            }
            this.setState({
              msjError : msjError,
              abrirModalError : true
            });
          });
    }

    // Permite establecer el valor de un componente en el wizard
    setValueComponentWizard = (nombreComponente, nombreWizard, valor) => {
        this.props.objetos[nombreWizard][nombreComponente] = {'value': valor};
    }

    // Permite obtener el valor de un componente en el wizard
    getValueComponentWizard = (nombreComponente, nombreWizard) => {
        if(this.props.objetos[nombreWizard][nombreComponente] !== undefined) {
            if(this.props.objetos[nombreWizard][nombreComponente] instanceof Object && 
                'value' in this.props.objetos[nombreWizard][nombreComponente])
                return this.props.objetos[nombreWizard][nombreComponente].value;
            else
                return this.props.objetos[nombreWizard][nombreComponente];
        }
        return undefined;
    }

    // Función que consulta la convocatoria vigente (para usuarios externos)
    getConvocatoria = () => {
        // Obtenemos los valores del wizard
        var idProcesoElectoral = this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idDetalleProceso = this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idEstado = this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var seccion = this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var claveElectorFuar = this.getValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL) : "";
        console.log(idProcesoElectoral);
        
       // Limpiando datos dirección
        if(this.props.objetos[etiquetas.WIZARD_DATOS_DIRECCION]){
            Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_DIRECCION], {
                'calleNumero': {'value': undefined}
                , 'colonia':  {'value': undefined}
                , 'cp': {'value': undefined}
                , 'idMunicipio': {'value': undefined}
                , 'idLocalidad': {'value': undefined}
            });
        }

        var postData = {
            "idProcesoElectoral" : idProcesoElectoral,
            "idDetalleProceso" : idDetalleProceso,
            "idEstado" : idEstado,
            "seccion" : seccion,
            "idDistrito" : 0,
            "id" : etiquetas.ID_PARAMETRO_ESTATUS_MODULO_REGISTRO_ASPIRANTES
          }

        // Obteniendo los datos del servidor
        axios.post(process.env.REACT_APP_API_URL +
            '/centralReclutaSEyCAE/ws/getEstatusModuloRegistroExterno', postData,
            {
                  headers: {
                      'Accept': 'application/json'
                      ,'Content-Type': 'application/json'
                  }
              }
          ).then(response => {
              // Si el registro de aspirantes se encuentra abierto
              if(response.data === 1) {
                var postData = {
                    "idProcesoElectoral" : idProcesoElectoral,
                    "idDetalleProceso" : idDetalleProceso,
                    "idEstado" : idEstado,
                    "seccion" : seccion,
                    "claveElectorFuar" : claveElectorFuar,
                    "esJuntaDistrital": this.props.datosUsuario !== undefined ? true : false
                  }
                  
                  // Obtenido los datos del servidor para consultar la convocatoria vigente
                  axios.post(process.env.REACT_APP_API_URL +
                    '/centralReclutaSEyCAE/ws/convocatoria', postData,
                    {
                          headers: {
                              'Accept': 'application/json'
                              ,'Content-Type': 'application/json'
                          }
                      }
                  ).then(response => {
                      if(response.data !== ""){
                          Object.assign(this.props.objetos
                            [etiquetas.WIZARD_DATOS_CREDENCIAL], response.data);          
                          this.setValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL, idProcesoElectoral);
                          this.setValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL, idDetalleProceso);
                          this.setValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL, idEstado);
                          this.setValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL, seccion);
                          this.setValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL, claveElectorFuar);

                          this.wizard.current.cambiaNegocio('seccion', true);
                      } else {
                          // Se envía mensaje de error, no se encontró convocatoria activa
                          this.callbackResponse({0: {seccion: {
                            error: etiquetas.gral_no_convo_activa_seccion
                          }}});
                      }
                  }).catch(error => {
                    console.error("Error al obtener la convocatoria externa getConvocatoria()",error);
                    msjError = etiquetas.gral_error_cau;
                    this.setState({ msjError : msjError, abrirModalError : true });
                  });
              } else {
                // Se envía el mensaje de error de módulo cerrado
                this.callbackResponse({0: {seccion: {
                    error: etiquetas.gral_modulo_cerrado
                  }}});
              }
          }).catch(error => {
                // Se envía mensaje de error, no se encontró convocatoria activa
                this.callbackResponse({0: {seccion: {
                    error: etiquetas.gral_no_convo_activa_seccion
                  }}});
          });
    }

    getMunicipios = async () => {
        // Obtenemos los valores del wizard
        var idProcesoElectoral = this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idDetalleProceso = this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idEstado = this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var seccion = this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

        var postData = {
            idProcesoElectoral : idProcesoElectoral,
            idDetalleProceso : idDetalleProceso,
            idEstado : idEstado,
            seccion : seccion
        }

        // Obtenido los datos del servidor
        const response = await axios.post(process.env.REACT_APP_API_URL +
          '/centralReclutaSEyCAE/ws/municipios'
            , postData,
            {
                headers: {
                    'Accept': 'application/json'
                    ,'Content-Type': 'application/json'
                }
            }
        );
        return await response.data;
    }

    /*
    *
    **/
    getLocalidades = async () => {
        // Obtenemos los valores del wizard
        var idProcesoElectoral = this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idDetalleProceso = this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idEstado = this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var seccion = this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                this.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        var idMunicipio = this.getValueComponentWizard('idMunicipio', etiquetas.WIZARD_DATOS_DIRECCION) ? 
                this.getValueComponentWizard('idMunicipio', etiquetas.WIZARD_DATOS_DIRECCION) : 0;

        if (idProcesoElectoral === 0)
            idProcesoElectoral = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idProcesoElectoral;

      var postData = {
        idProcesoElectoral : idProcesoElectoral,
        idDetalleProceso : idDetalleProceso,
        idEstado : idEstado,
        seccion : seccion,
        idMunicipio : idMunicipio
      }
        // Obtenido los datos del servidor
        const response = await axios.post(
          process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/localidades'
          ,postData,
          {
            headers: {
                'Accept': 'application/json'
                ,'Content-Type': 'application/json'
            }
          }
        );
        return await response.data;
    }

    /**
    *
    **/
    getEscolaridades = async () => {
        const response = await axios.post(
        process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/escolaridades'
          , {}
          , {
              headers: {
                  'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
              }
          }
        );
        return await response.data;
    }

    /**
    * Se ontiene los medios de difusión.
    **/
    getMediosDifusionAspirante = async () => {
        const response = await axios.post(process.env.REACT_APP_API_URL +
                           '/centralReclutaSEyCAE/ws/medios_difusion_aspirante',
            {},
            {
              headers: {
                  'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
              }
            }
        );
        return await response.data;
    }

    getConvocatorias = async () => {
        const { proceso } = this.props;
        const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
        const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

        // Validando que este establecido el valor de Estado
        if(!this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value
           && !this.props.objetos [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value) {
             return
        }
        var postData = {
          idProcesoElectoral : idProcesoElectoral,
          idDetalleProceso : idDetalleProceso,
          idEstado : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value,
          seccion : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value
        }

        // Obtenido los datos del servidor
        const response = await axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/convocatorias'
            , postData,
            {
                headers: {
                    'Accept': 'application/json'
                    ,'Content-Type': 'application/json'
                }
            }
        );
        return await response.data;
    }

    getAvisos = async (idProcesoElectoral, idDetalleProceso) => {
        if (idProcesoElectoral !== null && idDetalleProceso !== null &&
           (idProcesoElectoral !== undefined && idDetalleProceso !== undefined)){
            var postData = {
                idProcesoElectoral: idProcesoElectoral,
                idDetalleProceso: idDetalleProceso
            }
            // Consultamos los avisos de privacidad
            const response = await axios.post(process.env.REACT_APP_API_URL +
                '/centralReclutaSEyCAE/ws/avisos'
                , postData,
                {
                    headers: {
                        'Accept': 'application/json'
                        , 'Content-Type': 'application/json'
                    }
                }
            );
            return await response.data;
        }
    }
	
	/** Función que obtiene la fecha de contratación - parámetro 20 en SUPYCAP.C_FECHAS	**/
    getFechaContratacion = async () => {
        const idEstado = this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
            this.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        const idProcesoElectoral = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idProcesoElectoral'].value !== undefined ?
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idProcesoElectoral'].value :
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idProcesoElectoral'] !== undefined ?
                this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idProcesoElectoral'] : 0;

        const idDetalleProceso = this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
            this.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

        var postData = {
            idProcesoElectoral: idProcesoElectoral,
            idDetalleProceso: idDetalleProceso,
            idEstado: idEstado,
            idDistrito: 0,
            id: etiquetas.ID_FECHA_INICIO_CONTRATACION_CAE
        }
        // Consultamos la feccha de contratación
        const response = await axios.post(process.env.REACT_APP_API_URL +
            "/centralReclutaSEyCAE/ws/getFecha"
            , postData,
            {
                headers: {
                    'Accept': 'application/json'
                    , 'Content-Type': 'application/json'
                }
            }
        );
        return await response.data;
    }

    validaAuthenticated = () => {
        if (this.props.datosUsuario &&
                                  this.props.datosUsuario.tipoUsuario === 'I') {
            this.setState({
              guia: false, // Se esconde el componente de guia
              rolConsulta: (this.props.datosUsuario.rolUsuario === 'SCE.CAU.OC') // Se establece solo consulta
            },
            () => {
                if(!etiquetas.rolesCaptura.includes(this.props.datosUsuario.rolUsuario)){
                    this.handleAvisoUsuarioNovalidoClick(); // No se permite la entrada del usuario
                }
            }
          );
        }
    }

    handleAvisoUsuarioNovalidoClick = () => {
        this.setState({
            avisoUsuarioNovalidoVisible : true
        });
    }

    handleAvisoUsuarioNovalidoClose = () => {
        this.setState({
            avisoUsuarioNovalidoVisible : false
        }, this.props.history.goBack());
    }

    componentWillUnmount() {
        if (this.wizard.current)
            this.wizard.current.cleanWizard();
    }

    onClickModal = () =>{
        this.cerrarModal();
        this.setState({modalAbrir: false});
    }

    /**
    * Cierra la ventana modal
    **/
    cerrarModal(event) {
        var modal = document.getElementById("tvesModal");
        var body = document.getElementsByTagName("body")[0];
        modal.style.display = "none";

        body.style.position = "inherit";
        body.style.height = "auto";
        body.style.overflow = "visible";
    }

    onClickBotonRegresar = () => {
        const {datosUsuario} = this.props;

        //Direccionando por tipo de usuario
        if(!datosUsuario)
            this.props.history.push('/loginSEyCAE');
        else if(datosUsuario.tipoUsuario === 'I')
            this.props.history.push('/menuJDE');
        else {
            if (datosUsuario.datosAspirante.estatusRegistro === 1)
                this.props.history.push('/cargaDocumentos');
            else if (datosUsuario.datosAspirante.estatusRegistro === 2) {
                if (datosUsuario.datosAspirante.bObservacion)
                    this.props.history.push('/cargaDocumentos');
                else if (typeof datosUsuario.datosAspirante.bObservacion !== "number" &&
                datosUsuario.datosAspirante.bPlatica === 0)
                    this.props.history.push('/finalizado');
                else
                    this.props.history.push('/platica_induccion');
            }
            else if (datosUsuario.datosAspirante.estatusRegistro === 3){
                if(datosUsuario.datosAspirante.bPlatica === null){
                    this.props.history.push('/platica_induccion');
                }else {
                    this.props.history.push('/finalizado');
                }
            }
            else if (datosUsuario.datosAspirante.estatusRegistro === 4 || datosUsuario.datosAspirante.estatusRegistro === 5)
                this.props.history.push('/solicitud_declinada');
            else
                this.props.history.push('/enConstruccion');
        }
    }

    actualizarHeader = (nuevoTitulo) => {
        this.setState({tituloHeaderModule: nuevoTitulo});
    }

    obtenerEtiquetaNombreProceso = async (idProcesoElectoral, idEtiqueta) => {
        if (idProcesoElectoral !== null && idProcesoElectoral !== undefined){
            var postData = {
                idProcesoElectoral: idProcesoElectoral,
                id: idEtiqueta
            }
            // Obtenemos el nombre del Proceso Electoral
            const response = await axios.post(process.env.REACT_APP_API_URL +
                '/centralReclutaSEyCAE/ws/getEtiqueta'
                , postData,
                {
                    headers: {
                        'Accept': 'application/json'
                        , 'Content-Type': 'application/json'
                    }
                }
            );
            return await response.data;
        }
    }

    render() {
        const botonDeshabilitado = this.state.rolConsulta ? true :  this.state.disableAceptar;
        const boton = (<Button type="primary"
                            htmlType="submit"
                            disabled={botonDeshabilitado}
                            onClick={this.enviarServidor}>
                            Guardar cambios
                        </Button>);
        const {datosUsuario} = this.props;
        const tipoUsuario = datosUsuario && datosUsuario.tipoUsuario ? datosUsuario.tipoUsuario : '';

        return(
            <AuthenticatedComponent listo={this.validaAuthenticated}
                    privado={false}>
                <Template  tituloHeaderModule={this.state.tituloHeaderModule} contenido={
                    <>
                        {
                            tipoUsuario === 'I' ?
                                <Menu /> : ""
                        }
                        <div className='registro_container'>
                            {
                                tipoUsuario === 'I' || tipoUsuario === 'E' ?
                                <Row className={tipoUsuario === 'E' ? 'aspirante_externo_modulo_modifica' : ''}>
                                    <Col sm={24} md={24} lg={24}>
                                        <HeaderModule title={this.state.tituloHeaderModule} />
                                    </Col>
                                </Row> : ""
                            }

                            <div className='header_registro'>
                            <Row gutter={16} id="titulo-barra-progreso">
                                <Col sm={3} md={3} lg={3}>
                                <div className={this.state.porcentaje > 9  ? "lleno" : "vacio"}>
                                    Datos Personales
                                </div>
                                </Col>
                                <Col sm={3} md={3} lg={3}>
                                <div className={this.state.porcentaje > 27  ? "lleno" : "vacio"}>
                                    Domicilio
                                </div>
                                </Col>
                                <Col sm={3} md={3} lg={3}>
                                <div className={this.state.porcentaje > 36   ? "lleno" : "vacio"}>
                                    Datos curriculares
                                </div>
                                </Col>
                                <Col sm={3} md={3} lg={3}>
                                <div className={this.state.porcentaje > 54  ? "lleno" : "vacio"}>
                                    Experiencia Laboral
                                </div>
                                </Col>
                                <Col sm={9} md={9} lg={9}>
                                <div className={this.state.porcentaje > 63  ? "lleno" : "vacio"}>
                                    Otros datos
                                </div>
                                </Col>
                            </Row>
                                <div className='contenedor_progreso'>
                                    <ProgresoRegistro porcentaje={this.state.porcentaje}/>
                                </div>
                            </div>
                            <Layout className='form_registro'>
                                <Sider theme='light' className=
                                {window.location.pathname === '/registro_aspirante'?
                                'ocultarImagen side_registro' : 'side_registro'} width='41%'>
                                    <img id="siderRegistro" src={siderRegistro} alt=""/>
                                </Sider>
                                <Content className="contenido_anidado">
                                    <Form
                                        layout="horizontal"
                                        labelAlign='left'
                                        colon={true}>
                                        <Wizard referencia={this.wizard}
                                                lista={[
                                                    <DatosCredencial
                                                        callbackResponse={this.callbackResponse}
                                                        getValidaConvocatoria={this.getValidaConvocatoria}
                                                        getConvocatoria={this.getConvocatoria}
                                                        getConvocatorias={this.getConvocatorias}
                                                        getValueComponentWizard={this.getValueComponentWizard}
                                                        setValueComponentWizard={this.setValueComponentWizard}
                                                        getEscolaridades={this.getEscolaridades}
                                                        getMediosDifusionAspirante={this.getMediosDifusionAspirante}
                                                        getAvisos={this.getAvisos}
                                                        getMunicipios={this.getMunicipios} 
                                                        getFechaContratacion={this.getFechaContratacion}
                                                        modifica = {this.props.modifica}
                                                        soloFuar ={this.props.fuar}
                                                        wizard={this.wizard}
                                                        objetos={this.props.objetos}
                                                        actualizarHeader={this.actualizarHeader}
                                                        actualizaTipoUser = {this.actualizaTipoUser} 
                                                        obtenerEtiquetaNombreProceso = {this.obtenerEtiquetaNombreProceso} />,
                                                    <DatosPersonales
                                                        getValueComponentWizard={this.getValueComponentWizard}
                                                        setValueComponentWizard={this.setValueComponentWizard}
                                                        callbackResponse={this.callbackResponse}
                                                        wizard={this.wizard}
                                                        modifica = {this.props.modifica}
                                                        objetos={this.props.objetos}/>,
                                                    <DatosDireccion
                                                        getValueComponentWizard={this.getValueComponentWizard}
                                                        setValueComponentWizard={this.setValueComponentWizard}
                                                        wizard={this.wizard}
                                                        modifica = {this.props.modifica}
                                                        callbackResponse={this.callbackResponse}                                                        
                                                        getLocalidades={this.getLocalidades}
                                                        objetos={this.props.objetos}/>,
                                                    <DatosEscolaridad
                                                        objetos={this.props.objetos}
                                                        callbackResponse={this.callbackResponse}/>,
                                                    <MedioConvocatoria
                                                        callbackResponse={this.callbackResponse}                                                     
                                                        motivoParticipar={this.stateModifica.motivoParticipar} 
                                                        objetos={this.props.objetos} />,
                                                    <ExperienciaLaboral
                                                        callbackResponse={this.callbackResponse}/>,
                                                    <DatosOtros1
                                                        callbackResponse={this.callbackResponse}/>,
                                                    <DatosOtros2
                                                        callbackResponse={this.callbackResponse}
                                                        getValueComponentWizard={this.getValueComponentWizard}
                                                        wizardDatosCred={this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]}/>,
                                                    <DatosOtros3
                                                        callbackResponse={this.callbackResponse}/>,
                                                    <DatosOtros4
                                                        callbackResponse={this.callbackResponse}/>,
                                                    <DatosOtros5
                                                        callbackResponse={this.callbackResponse}
                                                        objetos={this.props.objetos}/>, 
                                                ]}
                                                objetos={this.props.objetos}
                                                callValidacion={this.formularioCorrecto}
                                                callbackPaso={this.callbackPaso}
                                                modifica={this.props.modifica}
                                                botonFinal={boton}
                                                datosU={this.stateModifica.datosUsuario}
                                                soloFUAR={this.stateModifica.soloFUAR}
                                        />
                                    </Form>
                                </Content>
                            </Layout>
                        </div>
                    </>
                }
                bloqueado={!this.state.cargado}
                guia={this.state.guia && this.state.statusVisible}
                cargando={this.state.cargando}
                />
                <Modal
                  className="modalError"
                  title={<img  src={errorImgModal} id="img-error-modal"/>}
                  centered
                  onCancel={()=>this.cerrarErrorModal()}
                  visible={this.state.abrirModalError}
                  footer={false}
                  width={400}
                >
                  {this.state.msjError}
                </Modal>
                <Modal
                    title={null}
                    footer={null}
                    centered={true}
                    visible={this.state.avisoUsuarioNovalidoVisible}
                    onOk={this.handleAvisoUsuarioNovalidoClose}
                    onCancel={this.handleAvisoUsuarioNovalidoClose}>
                    <div>
                        <h3 style={{'textAlign': 'center'}}>PERMISOS INSUFICIENTES</h3>
                        <h5 style={{'textAlign': 'center'}}>No tiene permiso para realizar esta acción.</h5>
                    </div>
                </Modal>
                <Modal title={null}
                       centered
                       visible={this.state.modalAbrir}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}>
                    <div style={{'fontSize': '16px'}}>
                        {this.state.mjs}
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={this.onClickModal}> Aceptar </Button>
                    </div>
                </Modal>
            </AuthenticatedComponent>
        );
    }
};

const mapStateToProps = createStructuredSelector({
    datosUsuario: selectCurrentUser,
    estado: selectEstado,
    proceso: selectProceso,
    distrito: selectDistrito,
    datosAspirante: selectAspirante,
});

const mapDispatchToProps = dispatch => ({
	cambiarEstatus: nuevoEstatus => dispatch(cambiarEstatus(nuevoEstatus)),
	registrarTerminado: exito => dispatch(registrarTerminado(exito)),
    emitirOperacion: valor => dispatch(emitirOperacion(valor))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Aspirante));
